import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Savings } from "./savings.model";
import { DatePipe } from '@angular/common';
import { Ledger} from "../../master/ledger/shared/ledger";

@Injectable({
  providedIn: 'root'
})

export class SavingsService {

  public selectedSavings : Savings;
  public selectedLedger: Ledger;

  constructor( private httpClient: HttpClient,private datePipe: DatePipe){ }

  getBaseUrl() {  
    return environment.baseUrl;
   }  

   IUDSavings(savings: Savings) {

    // console.log(savings);
    
    // savings.CompanyId = + JSON.parse(localStorage.getItem("EmployeeData"))["CompanyId"];
    // savings.EmployeeBranchId = + JSON.parse(localStorage.getItem("EmployeeData"))["BranchId"];
    // savings.EmployeeId =+ JSON.parse(localStorage.getItem("EmployeeData"))["Id"];
    // savings.SaasId = + JSON.parse(localStorage.getItem("EmployeeData"))["SaasId"];

    // var body = JSON.stringify(savings);
    // var headerOptions = new Headers({ 'Content-Type': 'application/json' });
    // var requestOptions = new RequestOptions({ method: RequestMethod.Post, headers: headerOptions });
    // return this.http.post(this.getBaseUrl() + 'api/Savings/IUD', body, requestOptions).map(x => x.json());
    savings.CompanyId = + JSON.parse(localStorage.getItem("EmployeeData"))["CompanyId"];
    savings.EmployeeBranchId = + JSON.parse(localStorage.getItem("EmployeeData"))["BranchId"];
    savings.EmployeeId =+ JSON.parse(localStorage.getItem("EmployeeData"))["Id"];
    savings.SaasId = + JSON.parse(localStorage.getItem("EmployeeData"))["SaasId"];
    savings.CreatedDate  = new Date((localStorage.getItem("ApplicationDate")));
    savings.ModifiedDate = new Date((localStorage.getItem("ApplicationDate")));

   let body = savings;
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>(this.getBaseUrl() + 'api/Savings/IUD', body, { headers: headers });
  }


  FetchSavingsById(savings: Savings){

    savings.CompanyId = + JSON.parse(localStorage.getItem("EmployeeData"))["CompanyId"];
    savings.EmployeeBranchId = + JSON.parse(localStorage.getItem("EmployeeData"))["BranchId"];
    savings.EmployeeId =+ JSON.parse(localStorage.getItem("EmployeeData"))["Id"];
    savings.SaasId = + JSON.parse(localStorage.getItem("EmployeeData"))["SaasId"];

  //   var body = JSON.stringify(savings);
  //   var headerOptions = new Headers({ 'Content-Type': 'application/json' });
  //   var requestOptions = new RequestOptions({ method: RequestMethod.Post, headers: headerOptions });
  //   return this.http.post(this.getBaseUrl() + 'api/Savings/Fetch', body, requestOptions).map(x => x.json());

// console.log(savings);

    let body = savings;
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>(this.getBaseUrl() + 'api/Savings/Fetch', body, { headers: headers });
  }

  FetchSavingsList(){

    this.selectedSavings= new Savings();
    this.selectedSavings.CompanyId = + JSON.parse(localStorage.getItem("EmployeeData"))["CompanyId"];
    this.selectedSavings.EmployeeBranchId = + JSON.parse(localStorage.getItem("EmployeeData"))["BranchId"];
    this.selectedSavings.EmployeeId =+ JSON.parse(localStorage.getItem("EmployeeData"))["Id"];
    this.selectedSavings.SaasId = + JSON.parse(localStorage.getItem("EmployeeData"))["SaasId"];

  //   var body = JSON.stringify(this.selectedSavings);
  //   var headerOptions = new Headers({ 'Content-Type': 'application/json' });
  //   var requestOptions = new RequestOptions({ method: RequestMethod.Post, headers: headerOptions });
  //   return this.http.post( this.getBaseUrl() +  'api/Savings/FetchList', body, requestOptions).map(x => x.json());
  
    let body = this.selectedSavings;
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>(this.getBaseUrl() + 'api/Savings/FetchList', body, { headers: headers });
  }

  FetchSavingsSchemeList(){

    this.selectedSavings = new Savings();
    this.selectedSavings.CompanyId = + JSON.parse(localStorage.getItem("EmployeeData"))["CompanyId"];
    this.selectedSavings.EmployeeBranchId = + JSON.parse(localStorage.getItem("EmployeeData"))["BranchId"];
    this.selectedSavings.EmployeeId =+ JSON.parse(localStorage.getItem("EmployeeData"))["Id"];
    this.selectedSavings.SaasId = + JSON.parse(localStorage.getItem("EmployeeData"))["SaasId"];

    let body = this.selectedSavings;
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>(this.getBaseUrl() + 'api/SavingsScheme/FetchList', body, { headers: headers });
  }

  // FetchAutogeneratedNumber() {
  //   var body = JSON.stringify('');
  //   var headerOptions = new Headers({ 'Content-Type': 'application/json' });
  //   var requestOptions = new RequestOptions({ method: RequestMethod.Post, headers: headerOptions });
  //   return this.http.post(this.getBaseUrl() + 'api/CommonMaster/AutoGeneratedNumber', body, requestOptions).map(x => x.json());
  // }

  // FetchAgentList(){
  //   this.selectedSavings= new Savings();
  //   this.selectedSavings.CompanyId = + JSON.parse(localStorage.getItem("EmployeeData"))["CompanyId"];
  //   this.selectedSavings.EmployeeBranchId = + JSON.parse(localStorage.getItem("EmployeeData"))["BranchId"];
  //   this.selectedSavings.EmployeeId =+ JSON.parse(localStorage.getItem("EmployeeData"))["Id"];
  //   this.selectedSavings.SaasId = + JSON.parse(localStorage.getItem("EmployeeData"))["SaasId"];

  //   var body = JSON.stringify(this.selectedSavings);
  //   var headerOptions = new Headers({ 'Content-Type': 'application/json' });
  //   var requestOptions = new RequestOptions({ method: RequestMethod.Post, headers: headerOptions });
  //   return this.http.post( this.getBaseUrl() +  'api/CommonMaster/Agent', body, requestOptions).map(x => x.json());
  // }

  FetchCustomerList(){
    this.selectedSavings= new Savings();
    this.selectedSavings.IsCustomerSearch = true;
    this.selectedSavings.CompanyId = + JSON.parse(localStorage.getItem("EmployeeData"))["CompanyId"];
    this.selectedSavings.EmployeeBranchId = + JSON.parse(localStorage.getItem("EmployeeData"))["BranchId"];
    this.selectedSavings.EmployeeId =+ JSON.parse(localStorage.getItem("EmployeeData"))["Id"];
    this.selectedSavings.SaasId = + JSON.parse(localStorage.getItem("EmployeeData"))["SaasId"];

    // var body = JSON.stringify(this.selectedSavings);
    // var headerOptions = new Headers({ 'Content-Type': 'application/json' });
    // var requestOptions = new RequestOptions({ method: RequestMethod.Post, headers: headerOptions });
    // return this.http.post( this.getBaseUrl() +  'api/Customers/FetchList', body, requestOptions).map(x => x.json());
    let body = this.selectedSavings;
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>(this.getBaseUrl() + 'api/Customers/FetchList', body, { headers: headers });
  }
  
  GetSavingsIdByCustomerId(SearchData : any){
    this.selectedSavings = new Savings();
    this.selectedSavings.CustomerId  = SearchData.CustomerId;
    this.selectedSavings.BranchId = + SearchData.BranchId;

    this.selectedSavings.IsCustomerSearch = true;
    this.selectedSavings.CompanyId = + JSON.parse(localStorage.getItem("EmployeeData"))["CompanyId"];
    this.selectedSavings.EmployeeId =+ JSON.parse(localStorage.getItem("EmployeeData"))["Id"];
    this.selectedSavings.SaasId = + JSON.parse(localStorage.getItem("EmployeeData"))["SaasId"];

    let body = this.selectedSavings;
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>(this.getBaseUrl() + 'api/Savings/FetchList', body, { headers: headers });
  }

  FetchBankLedgerList(){
    
    this.selectedLedger  = new Ledger();
    this.selectedLedger.BranchId = + JSON.parse(localStorage.getItem("EmployeeData"))["BranchId"];
    this.selectedLedger.CompanyId = + JSON.parse(localStorage.getItem("EmployeeData"))["CompanyId"];
    this.selectedLedger.EmployeeBranchId = + JSON.parse(localStorage.getItem("EmployeeData"))["BranchId"];
    this.selectedLedger.EmployeeId =+ JSON.parse(localStorage.getItem("EmployeeData"))["Id"];
    this.selectedLedger.SaasId =  JSON.parse(localStorage.getItem("EmployeeData"))["SaasId"];
    this.selectedLedger.IsBranchWise = true;

    let body =  this.selectedLedger;
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>( this.getBaseUrl() +  'api/Ledger/FetchList', body,{headers: headers});
   }
}
